export default __webpack_public_path__ + "static/media/logo.064fe782.svg";